import Vue from 'vue';
import Axios from 'axios';
import { handleError } from '@/_helpers/utils.js';

const check_invalid_tag = tag => {
  if (tag.name.trim().length === 0) return 'Имя тега не может быть пустым';
  return false;
};

export default {
  namespaced: true,
  state() {
    return {
      data: {},
      loaded: false,
      error: null
    };
  },

  actions: {
    async load(context) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);

      return await Axios.get(`/1.0/response/tags`)
        .then(response => response.data.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        });
    },

    edit(context, id) {
      const item = context.getters.get_item(id);
      if (!item.created) { // Если тег ещё не был создан, меняем действие
        return context.dispatch('create', id)
      }
      const error = check_invalid_tag(item);
      if (error) {
        context.commit('set_item_key', {id, key: 'error', value: error});
        return Promise.reject(error);
      }
      context.commit('set_item_key', {id, key: 'loading', value: true});
      context.commit('set_item_key', {id, key: 'error', value: null});
      return axios.put(`/1.0/response/tags/${id}`, {name: item.name})
        .then(response => response.data)
        .then(data => {
          context.commit('set_item', {
            ...data,
            error: null,
            created: true,
            saved: true,
            loading: false
          });
          context.commit('response/edit_tag', data, {root: true});
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_item_key', {id, key: 'loading', value: false});
          context.commit('set_item_key', {id, key: 'error', value: err});
          throw err;
        })
    },
    create(context, id) {
      const item = context.getters.get_item(id);
      const error = check_invalid_tag(item);
      if (error) {
        context.commit('set_item_key', {id, key: 'error', value: error});
        return Promise.reject(error);
      }
      context.commit('set_item_key', {id, key: 'loading', value: true});
      context.commit('set_item_key', {id, key: 'error', value: null});
      return axios.post(`/1.0/response/tags`, {name: item.name})
        .then(response => response.data)
        .then(data => {
          context.commit('set_item', {
            ...data,
            error: null,
            created: true,
            saved: true,
            loading: false
          });
          context.commit('remove_item', id);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_item_key', {id, key: 'loading', value: false});
          context.commit('set_item_key', {id, key: 'error', value: err});
          throw err;
        })
    },
    remove(context, id) {
      const item = context.getters.get_item(id);
      if(!item.created) { // Если удаляем тег, который не успели сохранить на сервере
        context.commit('remove_item', id);
        return Promise.resolve();
      }
      context.commit('set_item_key', {id, key: 'loading', value: true});
      context.commit('set_item_key', {id, key: 'error', value: null});
      return axios.delete(`/1.0/response/tags/${id}`)
        .then(response => response.data)
        .then(data => {
          context.commit('remove_item', id);
          context.commit('response/remove_tag', id, {root: true});
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_item_key', {id, key: 'loading', value: false});
          context.commit('set_item_key', {id, key: 'error', value: err});
          throw err;
        })
    }
  },
  mutations: {
    set_data(state, data) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        item.error = null;
        item.created = true;
        item.saved = true;
        item.loading = false;
        Vue.set(state.data, item.id, item);
      }
    },
    set_item(state, item) {
      Vue.set(state.data, item.id, item);
    },
    create_item_template(state) {
      const item = {
        id: Date.now(),
        name: '',
        error: null,
        created: false,
        saved: false,
        loading: false
      };
      Vue.set(state.data, item.id, item);
    },
    edit_item_name(state, {id, name}) {
      const tag = state.data[id];
      if (tag.saved) {
        Vue.set(tag, 'saved', false);
      }
      if (tag.error) {
        Vue.set(tag, 'error', null);
      }
      Vue.set(tag, 'name', name);
    },
    set_item_key(state, {id, key, value}) {
      Vue.set(state.data[id], key, value);
    },
    remove_item(state, id) {
      Vue.delete(state.data, id);
    },
    set_loaded(state, loaded) {
      state.loaded = loaded;
    },
    set_error(state, error) {
      state.error = error;
    }
  },
  getters: {
    list: (state) => Object.keys(state.data).map(id => state.data[id]),
    list_saved: (state, getters) => getters.list.filter(tag => tag.saved),
    error: (state) => state.error,
    loaded: (state) => state.loaded,
    get_item: (state) => (id) => state.data[id]
  }
}